import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { fillString } from '@local_modules/generic/string-template.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { context, updateView } from './update-view.js'
import { showSelectors } from './show-selectors.js'
import { activateActions } from './activate-actions.js'

/**
 *
 * @returns
 */
export async function showPageJournalsMonthlyValuesPgLedger (params) {
  console.log('showPageJournalsMonthlyValuesPgLedger', params)
  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Monthly Values:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  context.browserAppAccount = browserAppAccount

  showSelectors(updateView, browserAppAccount)

  activateActions(document.getElementById(elementId))
}
